
import { Component, Prop, Vue } from "vue-property-decorator";
import { GuestbookFamilyVisits } from "@/models/guestbook/GuestbookFamilyVisits";
import { GuestbookVisitor } from "@/models/guestbook/GuestbookVisitor";
import { ValidationProvider, ValidationObserver } from "vee-validate/dist/vee-validate.full";
import { alpha, numeric } from 'vee-validate/dist/rules';

@Component({
  components: {
    ValidationProvider,
    ValidationObserver
  },
})
export default class AddVisitor extends Vue {
  @Prop() guestbookVisit: GuestbookFamilyVisits;

  dialog = false;
  newVisitor: { name: string; phone: string } = { name: "", phone: "" };

    $refs!: {
      observer: HTMLFormElement;
      form: HTMLFormElement;
    };

  get rules(): object {
    return {
      alpha: alpha,
      numeric: numeric,
    };
  }

  addVisitor() {
    const form = this.$refs.form as any;
    const validated = form.validate();

    if (!validated) return;

    const GuestbookVisitorNew = new GuestbookVisitor(this.newVisitor.name, this.newVisitor.phone);

    this.guestbookVisit.visitors.push(
      {...GuestbookVisitorNew}
    );

    this.$store.dispatch("updateVisit", {
      guestbookitem: this.guestbookVisit,
      updateTime: false
    });

    this.dialog = false;
    this.newVisitor = { name: "", phone: "" };
    this.$refs.form.reset();
    this.$refs.observer.reset();
  }
}
